var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0221 1.62977C4.77674 1.62977 3.62977 2.66302 3.62977 3.97113V6.4208H2V3.97113C2 1.68242 3.9593 0 6.0221 0C8.01229 0 10.0147 1.63936 10.0147 3.97113V6.4208H8.38491V3.97113C8.38491 2.63385 7.20958 1.62977 6.0221 1.62977Z",
    fill: "#4F5662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6.41284C1.11929 6.41284 0 7.53213 0 8.91284V13.5C0 14.8807 1.11929 16 2.5 16H10.2827C11.6634 16 12.7827 14.8807 12.7827 13.5V8.91284C12.7827 7.53213 11.6634 6.41284 10.2827 6.41284H2.5ZM6.39058 12.8257C7.28083 12.8257 8.00252 12.104 8.00252 11.2138C8.00252 10.3235 7.28083 9.60186 6.39058 9.60186C5.50033 9.60186 4.77864 10.3235 4.77864 11.2138C4.77864 12.104 5.50033 12.8257 6.39058 12.8257Z",
    fill: "#4F5662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.194983ca4a973082437320b2c733d693.svg";
export { ForwardRef as ReactComponent };